import withNotFound, { NotFound } from 'bundles/common/components/withNotFound';

const PageDataErrorHandler = withNotFound({ test: () => true })(NotFound);

export default PageDataErrorHandler;
